import angular from 'angular';
import './changelog.styles.scss';

export default angular.module('directives.abChangelog', [])
  .directive('abChangelog', () => {
    'ngInject';

    return {
      controller: 'changelogController',
      restrict: 'E',
      replace: true,
      // @ts-ignore
      templateUrl: require('./changelog.template.html'),
      scope: {
        showChangelog: '=',
      },
    };
  })
  .controller('changelogController', ($scope, $rootScope) => {
    'ngInject';

    const VERSION_NUMBER = '5.2.7';

    const showChangelog = () => {
      $scope.showChangelog = true;
    };

    $scope.hideChangelog = () => {
      $scope.showChangelog = false;
      $rootScope.globals.version = VERSION_NUMBER;
    };

    const directiveInit = () => {
      if ($rootScope.globals === undefined) return;

      if ($rootScope.globals.version !== undefined) {
        if ($rootScope.globals.version !== VERSION_NUMBER) {
          showChangelog();
        }
      } else {
        $rootScope.globals.version = VERSION_NUMBER;
      }
    };

    directiveInit();
  })
  .name;
